
    /**
    * 获取图形验证码
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqApiEmployeeGraphGet28728 {}
    /**
 * YResult<GraphCodeResp> :YResult
 */
export class IResApiEmployeeGraphGet28728 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * GraphCodeResp
   */
  data?: {
    /**
     * 图形验证码
     */
    graphCode?: string;
    /**
     * 线索编号
     */
    clewNo?: string;
  };
  exceptionMsg?: {};
}
    const http: Serve<IReqApiEmployeeGraphGet28728, IResApiEmployeeGraphGet28728> = (data?) =>  request({
      method: 'GET',
      url: '/api/employee/graph/get',
      params: data
    }) 
    export default http